import type { ToGeoJSON } from '../../../types/apiModels'
import { apiClient } from '../../ruutsApi/client'
import endpoints from '../../ruutsApi/endpoints'
import { unwrapCollection } from '../../ruutsApi/normalize'

type OtherPolygon = {
  toGeoJSON: ToGeoJSON
}

export const getOtherPolygons = async ({
  farmId,
  signal,
}: {
  farmId: string
  signal?: AbortSignal
}): Promise<ToGeoJSON[]> => {
  const response = await apiClient.get(endpoints.otherPolygons, { params: { farmId }, signal })
  return unwrapCollection<OtherPolygon>(response).map(otherPolygon => otherPolygon.toGeoJSON)
}
